import { useNavigate } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { authApi } from '@/api/login';
import { AUTH_QUERY_KEY } from '@/lib/auth';

export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleLogout = async () => {
    queryClient.setQueryData(AUTH_QUERY_KEY, null);
    navigate({ to: '/login', replace: true });
    authApi.logout().catch((err) => console.error('Server logout failed:', err));
  };

  return { handleLogout };
}
